import Rating from './Rating'
import RichText from '@onclicks/sharedcomponents/RichText'
import { CarouselBlock } from '@onclicks/payload-types'
import { cn } from '@onclicks/utilities/ui'
import { courierPrime } from '@onclicks/utilities/fontImport'

type ItemFromCarousel = NonNullable<CarouselBlock['slides']>[number]

export default function Testimonial({
  testimonial,
  featured = false,
}: {
  testimonial: ItemFromCarousel
  featured?: boolean
}) {
  const { slideRichText, note, name } = testimonial

  return (
    <figure className="flex w-full flex-col items-center gap-4 text-center">
      {featured && <span className="font-serif text-5xl leading-none text-primary">&ldquo;</span>}

      {note && <Rating rating={note} size={featured ? 'lg' : 'sm'} />}

      {slideRichText && (
        <RichText
          data={slideRichText}
          enableGutter={false}
          enableProse={false}
          className={cn(
            `font-serif italic text-white/90 [&_p]:m-0 ${courierPrime.className}`,
            featured
              ? 'text-2xl leading-snug tracking-tight md:text-3xl'
              : 'text-sm leading-relaxed text-white/80',
          )}
        />
      )}

      <div className="mt-2 flex items-center gap-4">
        <span className="h-px w-8 bg-white/20" />
        <div className="flex flex-col items-center gap-0.5">
          {name && (
            <span className="text-[11px] font-semibold tracking-widest text-primary uppercase">
              {name}
            </span>
          )}
        </div>
        <span className="h-px w-8 bg-white/20" />
      </div>
    </figure>
  )
}
